import {
    GET_RULE,
    GET_RULE_SUCCESS,
    GET_RULE_FAILED,
  } from "./actionsTypes";
  
  export const getRule = (params) => {
    return {
      type: GET_RULE,
      payload: params
    };
  };
  
  export const getRuleSuccess = (rules) => {
    return {
      type: GET_RULE_SUCCESS,
      payload: rules,
    };
  };
  
  export const getRuleFailed = (error) => {
    return {
      type: GET_RULE_FAILED,
      payload: error,
    };
  };
  